let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k22Fv")).then(() => parcelRequire('ay6y4'));